// extracted by mini-css-extract-plugin
module.exports = {"patientLable":"patientLable_patientLable__2bREh","content":"patientLable_content__OXXle","autoLabel":"patientLable_autoLabel__3Mkt8"};